define('helperMisc-formatTime',[],function() {
    'use strict';

    //Convert duration from milliseconds to 0000:00:00.00 format
    var millisecondsToCMIDuration = function(n) {
        var hms = "",
            dtm = new Date();

        dtm.setTime(n);

        var h = "0" + Math.floor(n / 3600000),
            m = "0" + dtm.getMinutes(),
            s = "0" + dtm.getSeconds();

        hms = h.substr(h.length-2)+":"+m.substr(m.length-2)+":";
        hms += s.substr(s.length-2);

        return hms;
    };

    var centisecsToISODuration = function(n) {
        n = Math.max(n,0);
        var str = "P",
            nCs = n;

        var nY = Math.floor(nCs / 3155760000);
        nCs -= nY * 3155760000;
        var nM = Math.floor(nCs / 262980000);
        nCs -= nM * 262980000;
        var nD = Math.floor(nCs / 8640000);
        nCs -= nD * 8640000;
        var nH = Math.floor(nCs / 360000);
        nCs -= nH * 360000;
        var nMin = Math.floor(nCs /6000);
        nCs -= nMin * 6000
        // Now we can construct string
        if (nY > 0) str += nY + "Y";
        if (nM > 0) str += nM + "M";
        if (nD > 0) str += nD + "D";
        if ((nH > 0) || (nMin > 0) || (nCs > 0)) {
            str += "T";
            if (nH > 0) str += nH + "H";
            if (nMin > 0) str += nMin + "M";
            if (nCs > 0) str += (nCs / 100) + "S";
        }

        if (str == "P") str = "PT0H0M0S";
        return str;
    };

    return {
        millisecondsToCMIDuration:millisecondsToCMIDuration,
        centisecsToISODuration:centisecsToISODuration
    }



});



